module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "background.b2997a0c.jpg" + "?" + Date.now();